import React, { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { ClipboardList, LogOut, Plus, Users } from "lucide-react";

import { Button } from "~/components/ui/button";
import { supabase } from "~/integrations/supabase/client";
import { useProfileStore } from "~/store/profileStore";

export const MobileNavFooter: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { role } = useProfileStore();
  const [isClientDetailPage, setIsClientDetailPage] = useState(false);

  // Check if we're on a client detail page to highlight the appropriate button
  useEffect(() => {
    const isClientDetail = location.pathname.match(/^\/clients\/[^/]+$/);
    setIsClientDetailPage(!!isClientDetail);
  }, [location.pathname]);

  // Only show this footer for sellers
  if (role !== "seller") {
    return null;
  }

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  // Create a new sales request
  const handleNewSalesRequest = () => {
    // Navigate to the client selection page for creating a new sales request
    navigate("/clients");
  };

  const isActive = (path: string) => {
    // Special case for client details, highlight the clients button
    if (isClientDetailPage && path === "clients") {
      return true;
    }
    return location.pathname.includes(path);
  };

  return (
    <div className="fixed bottom-0 left-0 z-[100] w-full border-t border-gray-200 bg-white px-2 pb-2 pt-2 shadow-lg md:hidden">
      <div className="grid grid-cols-4 gap-1">
        <Button
          variant={isActive("sales-notes") ? "default" : "ghost"}
          size="sm"
          className="flex h-16 flex-col items-center justify-center rounded-md"
          onClick={() => navigate("/sales-notes")}
        >
          <ClipboardList className="mb-1 h-5 w-5" />
          <span className="text-xs">Ventas</span>
        </Button>

        <Button
          variant={isActive("clients") ? "default" : "ghost"}
          size="sm"
          className="flex h-16 flex-col items-center justify-center rounded-md"
          onClick={() => navigate("/clients")}
        >
          <Users className="mb-1 h-5 w-5" />
          <span className="text-xs">Clientes</span>
        </Button>

        <Button
          variant="default"
          size="sm"
          className="flex h-16 flex-col items-center justify-center rounded-md bg-blue-600 hover:bg-blue-700"
          onClick={handleNewSalesRequest}
        >
          <Plus className="mb-1 h-6 w-6" />
          <span className="text-xs">Nueva Venta</span>
        </Button>

        <Button
          variant="ghost"
          size="sm"
          className="flex h-16 flex-col items-center justify-center rounded-md text-red-500"
          onClick={handleLogout}
        >
          <LogOut className="mb-1 h-5 w-5" />
          <span className="text-xs">Salir</span>
        </Button>
      </div>
    </div>
  );
};

export default MobileNavFooter;
